const CNPJ_BODY_LENGTH = 12;
const CNPJ_LENGTH = 14;
const FIRST_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const SECOND_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export const normalizeCnpj = (value = "") => {
  return value.replace(/[./-]/g, "").toUpperCase();
};

const getCnpjCharValue = (char) => {
  return char.charCodeAt(0) - 48;
};

const calculateVerifierDigit = (value, weights) => {
  const total = value.split("").reduce((sum, char, index) => {
    return sum + getCnpjCharValue(char) * weights[index];
  }, 0);

  const remainder = total % 11;

  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCnpj = (value) => {
  const normalizedValue = normalizeCnpj(value);

  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(normalizedValue)) {
    return false;
  }

  if (normalizedValue.length !== CNPJ_LENGTH) {
    return false;
  }

  const body = normalizedValue.slice(0, CNPJ_BODY_LENGTH);
  const firstDigit = calculateVerifierDigit(body, FIRST_WEIGHTS);
  const secondDigit = calculateVerifierDigit(
    `${body}${firstDigit}`,
    SECOND_WEIGHTS
  );

  return normalizedValue === `${body}${firstDigit}${secondDigit}`;
};
